import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { sessionService } from "redux-react-session";
import { getAuth, signInWithCustomToken } from "firebase/auth/web-extension";
import { checkEmail, loaderSpinner } from "../images";
import CommonHeader from "../CommonHeader";
import CommonAuthHeader from "../options/CommonAuthHeader";
import {
  awaitingApproval,
  checkEmailMsg,
  checkEmailToApprove,
  resend,
  unrecognizedAlertMsg,
  unrecognizedAlertSubMsg,
} from "../messages";
import Text from "../text/Text";
import {
  callAPIInterface,
  generateToken,
  getUnRecognizedDeviceFireStoreData,
  handleAfterLoginProcess,
} from "../constants";
import { showToast } from "../../redux/actions";
import { CustomLink } from "../link/Link";
import DeviceApprovedModal from "./DeviceApprovedModal";
import { app } from "../../util/firebase";

function UnrecognizedDevice(props) {
  const [session, setSession] = useState(null);
  const [fireStoreData, setFireStoreData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const resendApproveDeviceEmail = () => {
    callAPIInterface("POST", "/login/user-device/resend-email", {})
      .then(() =>
        dispatch(
          showToast({
            isToastOpen: true,
            toastMessage: checkEmailToApprove,
            toastVariant: "success",
          })
        )
      )
      .catch((e) => e);
  };

  const getSession = () => {
    sessionService
      .loadSession()
      .then((session) => {
        setSession(session);
      })
      .catch((err) => {
        console.log("err::", err);
      });
  };

  const handleDeviceApprovedProcess = () => {
    generateToken().then(async () => {
      await handleAfterLoginProcess(navigate);
      setIsModalOpen(false);
    });
  };

  useEffect(() => {
    if (session?.firebase_token) {
      const authObj = getAuth(app);
      signInWithCustomToken(authObj, session?.firebase_token)
        .then(() => {
          const userId = authObj?.currentUser?.uid;
          const { session: sessionId } = session;
          getUnRecognizedDeviceFireStoreData(
            userId,
            sessionId,
            setFireStoreData
          );
        })
        .catch((_e) => {});
    }
  }, [session?.firebase_token]);

  useEffect(() => {
    if (fireStoreData?.session_state === "active") {
      setIsModalOpen(true);
      handleDeviceApprovedProcess();
    }
  }, [fireStoreData?.session_state]);

  useEffect(() => {
    getSession();
  }, []);

  return (
    <>
      <CommonHeader icon="backArrow" navigation="/" />
      <CommonAuthHeader showSpeedLogo={false}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          gap={1}
          marginTop={"50px"}
        >
          <img src={checkEmail} alt="check_email" height={180} width={180} />
          <Text size={22} font="bold">
            {unrecognizedAlertMsg}
          </Text>
          <Text size={14} font="regular" className="grey-text">
            {unrecognizedAlertSubMsg[0]}
            <br /> {unrecognizedAlertSubMsg[1]}
          </Text>
          <Box
            sx={{
              marginTop: "30px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              style={{ marginRight: "10px" }}
              src={loaderSpinner}
              alt="Loader"
              width={15}
              height={15}
            />
            <Text size={14} font="regular" className="grey-text">
              {awaitingApproval}
            </Text>
          </Box>
          <Text className="default-text mt-8" size={14}>
            {checkEmailMsg}
            <CustomLink bold size="small" onClick={resendApproveDeviceEmail}>
              &nbsp;{resend}
            </CustomLink>
          </Text>{" "}
        </Box>
      </CommonAuthHeader>

      {isModalOpen && (
        <DeviceApprovedModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </>
  );
}

export default UnrecognizedDevice;
